<p-toast [style]="{marginTop: '80px'}"></p-toast>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}

<h2>Reservation Revenue Report</h2>
<app-search-template
  searchLabel="Search"
  [showSearchButton]=true
  [reset]=true
  [showLocations]=true
  [showDevelopments]=true
  [showShortTermRentals]=true
  [showRateBuckets]=true
  [showBedrooms]=true
  [showSeasons]=true
  [showStartDate]=true
  [showEndDate]=true
  [startDate]="defaultStartDate"
  [endDate]="defaultEndDate"
  (doSearchCB)="onSearchSubmit($event)">
</app-search-template>
<br><br>

<h1>Reservation Total By Year</h1>
<app-res-rev-detail [resRevenues]="reservationsTotalsByYear"></app-res-rev-detail>

<br><br>
<h1>Reservation Total By Month</h1>
<app-res-rev-detail [resRevenues]="reservationsTotalsByMonth"></app-res-rev-detail>

<br><br>
<h1>Reservations</h1>
<app-res-rev-detail [resRevenues]="reservations"></app-res-rev-detail>